<template>
  <div class="main band-card">
    <ball></ball>
    <div>
      <Nav :title="navTitle"></Nav>
    </div>
    <!-- 
    @submit="submit"
   //触发提交事件
     -->
    <van-form validate-first @submit="submit">
      <!-- <van-field
        v-model="form.medCardNo"
        required
        size="large"
        label="就诊卡号"
        placeholder="请输入就诊卡号"
        :rules="[{required: true, message: '就诊卡号不能为空'}]"
      /> -->
      <van-field
        readonly
        required
        clickable
        size="large"
        label="证件类型"
        :value="certificateType"
        placeholder="选择证件类型"
       
        :rules="[{ required: true, message: '请选择证件类型' }]"
      />
      <van-field
        v-model="form.certificateNo"
        required
        type="textarea"
        rows="1"
        autosize
        size="large"
        label="证件号码"
        placeholder="请输入证件号码"
        :rules="[
          {
            required: true,
            message: '证件号码格式不正确',
            validator: certificateNoValidator,
          },
        ]"
      />
      <van-field
        v-model="form.clientName"
        required
        size="large"
        label="姓名"
        placeholder="请输入姓名"
        :rules="[{ required: true, message: '姓名不能为空' }]"
      />
      <!-- <van-field
        label="性别"
        required
        size="large"
        :rules="[{ required: true, message: '请选择性别' }]"
      >
        <template #input>
          <van-radio-group
            v-model="form.genderId"
            direction="horizontal"
            size="large"
          >
            <van-radio name="1">男</van-radio>
            <van-radio name="2">女</van-radio>
          </van-radio-group>
        </template>
      </van-field> -->
      <div class="submit">
        <!-- native-type="submit"  //触发提交事件 -->
        <van-button
          class="bottom_button"
          round
          block
          type="info"
          native-type="submit"
          size="nomal"
          >继续</van-button
        >
      </div>
    </van-form>
    <van-popup v-model="showPicker" round position="bottom">
      <van-picker
        show-toolbar
        :columns="IdCardList"
        value-key="name"
        @cancel="showPicker = false"
        @confirm="onConfirm"
      />
    </van-popup>
  </div>
</template>

<script>
import setOptions from "@/mixins/setOption";
import Nav from "@/components/nav.vue";
export default {
  mixins: [setOptions],
  data() {
    return {
      ispath: null,
      navTitle: "绑卡页面",
      IdCardList: [],
      showPicker: false,
      certificateType: "居民身份证",
      form: {
        medCardNo: this.$local.get("medCardNo"),
        clientName: "",
        genderId: "",
        certificateType: "1",
        certificateNo: "",
        openId: this.$local.get("openId"),
      },
    };
  },
  components: {
    Nav,
  },
  mounted() {
    this.getcoulms();
    if (this.$route.query.ispath) {
      this.ispath = this.$route.query.ispath;
    }
  },
  methods: {
    //导航返回
    onClickLeft() {
      this.$router.go(-1);
    },
    //获取证件列表
    async getcoulms() {
      try {
        this.$showLoad();
        let url = "/hospitalconf/index/getObjType";
        let data = null;
        await this.$axios_request.request_data(
          "nodeserver",
          url,
          "POST",
          null,
          (data) => {
            //证件类型
            this.IdCardList = data.data.idCardObj;
            this.$hideLoad();
          }
        );
      } catch (error) {
        console.log(error);
        this.$hideLoad();
      }
    },
    // 选中类型
    onConfirm(item) {
      this.certificateType = item.name;
      this.form.certificateType = item.value;
      this.showPicker = false;
      // console.log(this.from.certificateType)
    },
    // 证件号码校验

    certificateNoValidator(value) {
      if (this.form.certificateType === "1")
        return /^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X)$/.test(value);
      return true;
    },
    // 提交表单
    done() {
      console.log("abc");
    },
    async submit() {
      try {
        this.$showLoad();
        console.log(this.form.certificateNo);
        let url = "/medicalcard/bindcard";
        let reques_data = {
          certificateNo: this.form.certificateNo,
          clientName: this.form.clientName,
          certificateType: this.form.certificateType,
        };
        console.log(reques_data);
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "POST",
          reques_data,
          (data) => {
            this.$hideLoad();
            console.log(data);
            let state = data.data.state;
            console.log(state);
            let stateText = data.data.stateText;
            //用户 已绑卡 提示绑卡成功
            if (state && state == "1") {
              // this.$router.go(-1)
              this.$showDialog_confirm("绑卡成功", false, (action, done) => {
                if (action === "confirm") {
                  //done() 一定要有它  一定要有它 一定要有它 一定要有它 一定要有它
                  done();
                  if(this.ispath==1 ||this.ispath==2){
                   this.$toast.success("注册并绑定成功");
                setTimeout(() => {
                   this.$router.push({
                    path: "/confirmUser",
                    query: {
                      ispath: this.ispath,
                    },
                  });
                }, 1000);
                return
                }
                  this.$router.push('/patient_card_list_C');
                  return;
                }
              });
            }
            //his 已有档案号 但是信息输入错误
            else if (!state && state == "0") {
              this.$toast.fail("请核对身份证号以及姓名是否正确");
            }
            //绑卡失败
            else if (state && state == "3") {
              this.$toast.fail("绑卡失败，联系管理员");
              console.log("错误信息:    " + stateText);
            }
            //没有His档案号  跳转建档页
            else if (state && state == "2") {
               
              console.log(state);
              // state ==2
              this.$router.push({
                path: "/patient_card_create_C",
                query: {
                  clientName: this.form.clientName,
                  certificateType: this.form.certificateType,
                  certificateNo: this.form.certificateNo,
                  ispath: this.ispath,
                },
              });
              // console.log(this.form.certificateType);
            } else {
              this.$toast.fail("网络连接失败，联系管理员");
              console.log("错误信息:    " + stateText);
            }
          }
        );
      } catch (error) {
        console.log(error);
        this.$hideLoad();
        this.$toast.fail("身份绑定失败, 请核对绑定信息重试");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.main {
  width: 100vw;
  margin-bottom: 15px;
  // .submit {
  //   margin: 55px 20px 25px 20px;
  // }
  // 建档按钮
  .submit {
    margin: 0px 0px;
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 70px;
    display: flex;
    justify-items: center;
    align-items: center;
    background-color: #ffffff;
    border-top: 1px solid #aaaaaa;
    .bottom_button {
      width: 90%;
      margin: 0px auto;
      letter-spacing: 10px;
    }
  }
}
</style>
<style lang="scss">
.band-card {
  .van-cell {
    font-size: 16px;
  }
  .van-cell.van-cell--large {
    padding-top: 15px;
    padding-bottom: 15px;
  }
  .van-field__error-message {
    font-size: 14px;
  }
}
.van-button--round {
  border-radius: 10px;
}
</style>